import { useState, useEffect } from 'react';
import { eventScheduleService } from '@/features/events/services/eventScheduleService';
import type { EventDetailsResponse } from '@/features/events/types/types';

export const useEventData = (eventId: string | undefined) => {
    const [eventDetails, setEventDetails] = useState<EventDetailsResponse | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchEventData = async () => {
            if (!eventId) {
                setError('Event ID is required');
                setLoading(false);
                return;
            }

            try {
                setLoading(true);
                // Fetch event details
                const detailsResponse = await eventScheduleService.getEventDetails(eventId);
                setEventDetails(detailsResponse);
            } catch (err) {
                setError('Failed to load event data');
                console.error('Error fetching event data:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchEventData();
    }, [eventId]);

    return {
        eventDetails,
        loading,
        error
    };
};
